// Footer.js
import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <p>© 2024 My Dashboard</p>
    </footer>
  );
};

export default Footer;
